import $ from 'jquery';

// for header dropdown elements specifically
$('div.search-toggle').on('mouseup', function(e){
  $('.search-panel').toggleClass('show');
});

$('.outer-container').on('mousedown', function(e){
  if($('.search-panel').hasClass('show')) $('.search-panel').removeClass('show');
});

$(window).on('scroll', function(e){
  if($('.search-panel').hasClass('show')) $('.search-panel').removeClass('show');
});